import actions from './actions';


const initialState = {
    movsCajaAux: [],
    loadingMovsAux: false,
    loadedMovsAux: false,
    paginationMovsInfo: {},
    startDate: null,
    endDate: null,
};


export default function cajaReducer(state = initialState, action) {
    switch (action.type) {

        case actions.GET_MOV_AUX:
            return {
                ...state,
                loadedMovsAux: false,
                loadingMovsAux: true,
            }
        case actions.UPDATE_MOVS_AUX:
            return {
                ...state,
                movsCajaAux: action.payload,
                loadedMovsAux: true,
                loadingMovsAux: false,
            }
        case actions.SET_PAGINATION_MOVS_INFO:
            return {
                ...state,
                paginationMovsInfo: action.payload,
            };
        case actions.UPDATE_MOV_AUX_SUCCESS:
            return {
                ...state,
                movsCajaAux: state.movsCajaAux.map(mov => mov._id === action.payload._id ? action.payload : mov)
            };
        case actions.SET_RANGO:
            return {
                ...state,
                startDate: action.startDate,
                endDate: action.endDate
            };
        default:
            return state;
    }

}
